import React from 'react';

import styles from './index.module.css';

export class H1 extends React.Component<any, any> {
    render() {
        return <span className={[styles.h1, this.props.className].join(' ')}>{this.props.children}</span>;
    }
}
